const g = (capability, scope) => ({ capability, scope });
/** Бинарное право: включено = область 'org'. */
const b = (capability) => ({ capability, scope: 'org' });
/**
 * Системные роли. CLAUDE.md: неизменяемы, только клонирование.
 * Если разрешить правку, кто-то однажды добавит водителю `trust:read`,
 * и правило 17 отвалится молча, без единой ошибки в логах.
 */
export const SYSTEM_ROLES = [
    {
        key: 'driver',
        name: 'Driver',
        description: 'Performs inspections, reports defects, sees their own history.',
        level: 10,
        grants: [
            g('inspection:read', 'own'),
            g('inspection:create', 'own'),
            g('defect:read', 'own'),
            g('defect:create', 'own'),
            // Юниты своей площадки — нужно для выбора машины и разбора QR-кода.
            g('unit:read', 'site'),
        ],
    },
    {
        key: 'mechanic',
        name: 'Mechanic',
        description: 'Takes on defects and closes them with a photo of the completed work.',
        level: 20,
        grants: [
            g('defect:read', 'site'),
            g('defect:assign', 'site'),
            g('defect:close', 'site'),
            g('unit:read', 'site'),
            // Контекст осмотра, в котором дефект был найден.
            g('inspection:read', 'site'),
        ],
    },
    {
        key: 'auditor',
        name: 'Auditor',
        description: 'Read-only, possibly across several organizations. Every view is logged.',
        level: 20,
        grants: [
            g('inspection:read', 'org'),
            g('defect:read', 'org'),
            g('unit:read', 'org'),
            g('site:read', 'org'),
            b('audit:read'),
            b('evidence:export'),
        ],
    },
    {
        key: 'dispatcher',
        name: 'Dispatcher',
        description: 'Assigns drivers to units.',
        level: 30,
        grants: [
            g('unit:read', 'org'),
            g('unit:write', 'org'),
            g('user:read', 'org'),
            g('site:read', 'org'),
            g('inspection:read', 'org'),
            g('defect:read', 'org'),
        ],
    },
    {
        key: 'safety_manager',
        name: 'Safety manager',
        description: 'Inspection feed, defects, Trust Score, evidence export.',
        level: 40,
        grants: [
            g('inspection:read', 'org'),
            g('defect:read', 'org'),
            g('defect:create', 'org'),
            g('defect:assign', 'org'),
            g('defect:close', 'org'),
            g('unit:read', 'org'),
            g('site:read', 'org'),
            g('user:read', 'org'),
            b('trust:read'),
            b('evidence:export'),
            b('audit:read'),
            b('legal_hold:place'),
        ],
    },
    {
        key: 'fleet_admin',
        name: 'Fleet administrator',
        description: 'Templates, thresholds, people, sites.',
        level: 60,
        grants: [
            g('inspection:read', 'org'),
            g('inspection:create', 'org'),
            g('defect:read', 'org'),
            g('defect:create', 'org'),
            g('defect:assign', 'org'),
            g('defect:close', 'org'),
            g('unit:read', 'org'),
            g('unit:write', 'org'),
            g('site:read', 'org'),
            g('site:write', 'org'),
            g('user:read', 'org'),
            g('user:invite', 'org'),
            b('trust:read'),
            b('evidence:export'),
            b('audit:read'),
            b('template:write'),
            b('threshold:write'),
            b('policy:write'),
            b('legal_hold:place'),
            b('legal_hold:release'),
            b('retention:configure'),
            b('role:write'),
            b('user:role:grant'),
            b('org:settings'),
        ],
    },
    {
        key: 'owner',
        name: 'Owner',
        description: 'Full permissions, including billing and deleting the organization.',
        level: 100,
        grants: [
            g('inspection:read', 'org'),
            g('inspection:create', 'org'),
            g('defect:read', 'org'),
            g('defect:create', 'org'),
            g('defect:assign', 'org'),
            g('defect:close', 'org'),
            g('unit:read', 'org'),
            g('unit:write', 'org'),
            g('site:read', 'org'),
            g('site:write', 'org'),
            g('user:read', 'org'),
            g('user:invite', 'org'),
            b('trust:read'),
            b('evidence:export'),
            b('audit:read'),
            b('template:write'),
            b('threshold:write'),
            b('policy:write'),
            b('legal_hold:place'),
            b('legal_hold:release'),
            b('retention:configure'),
            b('retention:purge'),
            b('role:write'),
            b('user:role:grant'),
            b('org:settings'),
            b('org:billing'),
            b('support:impersonate'),
            b('org:delete'),
            b('audit:configure'),
        ],
    },
];
export const SYSTEM_ROLE_KEYS = SYSTEM_ROLES.map((r) => r.key);
export function findSystemRole(key) {
    return SYSTEM_ROLES.find((r) => r.key === key);
}
/** Роль, которая обязана существовать в организации — иначе клиент теряет доступ к себе. */
export const ORG_ADMIN_CAPABILITY = 'org:settings';
//# sourceMappingURL=roles.js.map